import { Element, useNode } from "@craftjs/core";
import HomeTitle from "./components/Title";
import HomeVideo from "./components/Video";

const HomeHeader = () => {
    const {
        connectors: { connect },
    } = useNode();

    return (
        <section id="page-hero" className="pt-15 mb-1" ref={(ref) => connect(ref!)}>
            <div className="container relative mx-auto 2xl:px-[108px] z-[1] grid grid-cols-1 lg:grid-cols-[minmax(100px,_550px)_1fr] gap-6 py-4">
                <Element id="home-title" is={HomeTitle} text="Simplifying the exchange process in a BIM project." />
                <Element id="home-video" is={HomeVideo} />
            </div>
        </section>
    );
};

HomeHeader.craft = {
    displayName: "Header",
    rules: {
        canDrag: () => false,
        canMoveOut: () => false,
    },
    custom: {
        canDelete: false,
    },
};

export default HomeHeader;
